import whoFooterLogo from "../../assets/images/aha-logo.svg";
import "./Footer.scss";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <aui-footer footertype="secondary" classnaming="">
            <footer className="aui-footer-secondary p-4">
                <div className="container-fuild d-flex">
                    <div className="p-3 border-right">
                        <img
                            className="aui-desktop-logo"
                            src={whoFooterLogo}
                            alt="AHA 100 years logo"
                        />
                    </div>
                    <div className="aui-footer-sec-inner text-white text-lg-left text-center p-3">
                        <p className="aui-font-14 mb-1">
                            Site powered by the American Heart Association
                        </p>
                        <div className="dropdown-divider d-lg-none d-block my-3"></div>
                        <p className="aui-font-14  mb-0">
                        &copy;{currentYear} American Heart Association, Inc. All rights reserved. Unauthorized use prohibited.
                        </p>
                    </div>
                </div>
            </footer>
        </aui-footer>
    );
};

export default Footer;